var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('IconAdd',{staticClass:"message-input-tool icon-small add icon-grey",nativeOn:{"click":function($event){return _vm.showEducationOptions.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }